import React, { useState, useEffect } from 'react';
import ReviewCard from '../components/ReviewCard';
import Loader from '../components/Loader';
import { fetchSavedKahanis } from '../api';

export default function SavedKahanisPage({ user }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSavedKahanis()
      .then(data => setReviews(data.reviews || []))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  }, []);

  const handleUnsave = (reviewId) => {
    setReviews(prev => prev.filter(r => (r.id || r._id) !== reviewId));
  };

  return (
    <div style={{ animation: 'fadeUp 0.35s ease-out' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 22, fontWeight: 900, margin: '0 0 4px', color: 'var(--text)' }}>
          Saved Kahanis
        </h1>
        <p style={{ fontSize: 13, color: 'var(--text3)', margin: 0 }}>
          Your privately saved interview experiences
        </p>
      </div>

      {loading ? (
        <Loader inline message="Loading saved kahanis..." />
      ) : reviews.length === 0 ? (
        <div style={{
          textAlign: 'center', padding: '60px 0',
          color: 'var(--text3)', fontSize: 14,
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🔖</div>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>No saved kahanis yet</div>
          <div style={{ fontSize: 13 }}>
            Click the bookmark icon on any kahani to save it here for later.
          </div>
        </div>
      ) : (
        reviews.map((r, i) => (
          <ReviewCard
            key={r.id || r._id || i}
            review={r}
            delay={i * 0.05}
            currentUser={user}
            onUnsave={handleUnsave}
          />
        ))
      )}
    </div>
  );
}
